import { useReveal } from './primitives';

/** Top-of-page hero: eyebrow, two-tone H1, lead, actions, optional visual on the right. */
export function PageHero({ eyebrow, title, lead, actions, aside, children }: {
  eyebrow: string;
  title: React.ReactNode;
  lead?: React.ReactNode;
  actions?: React.ReactNode;
  aside?: React.ReactNode;
  children?: React.ReactNode;
}) {
  const asideRef = useReveal<HTMLDivElement>(200);
  return (
    <section className="relative pt-28 pb-16 md:pt-36 md:pb-24">
      <div id="hero-sentinel" className="absolute top-0 left-0 w-1 h-1 pointer-events-none" />
      <div className="max-w-[1200px] mx-auto px-5 sm:px-8">
        <div className={aside ? 'grid grid-cols-1 lg:grid-cols-12 gap-12 items-center' : ''}>
          <div className={aside ? 'lg:col-span-6 min-w-0' : 'max-w-3xl'}>
            <div className="hero-enter">
              <p className="warm-eyebrow mb-6">{eyebrow}</p>
              <h1 className="font-display font-light text-[2.75rem] md:text-[3.75rem] leading-[1.05] tracking-tight" style={{ color: 'var(--warm-text)' }}>
                {title}
              </h1>
              {lead && <p className="mt-6 text-lg leading-relaxed max-w-xl" style={{ color: 'var(--warm-muted)' }}>{lead}</p>}
              {actions && <div className="mt-8 flex flex-wrap items-center gap-3">{actions}</div>}
            </div>
          </div>
          {aside && <div ref={asideRef} className="home-reveal lg:col-span-6 min-w-0">{aside}</div>}
        </div>
        {children}
      </div>
    </section>
  );
}
